import React from 'react'
import Errors from '../errors'

const ErrorsFr = () => {
    return <Errors languageCode="fr" />
}

export default ErrorsFr
